import actionTypes from '../../action-types'

export default (payload) => ({
  type: actionTypes.CUSTOMER.REQUEST_META,
  payload,
})
